import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'react-bootstrap';

const PartyListingFilterDrawer = ({
	filterDrawerVisible,
	setFilterDrawerVisible,
	partyType,
	setPartyType,
	partyTypeItems = [],
	searchText,
	setSearchText,
	searchPartyId,
	setSearchPartyId,
	fromDate,
	setFromDate,
	toDate,
	setToDate,
	loading,
	handleResetFilter,
	handleSearch,
}) => {
	const [todayActive, setTodayActive] = useState(false);
	const handleTodayFilter = () => {
		if (todayActive) {
		  setFromDate(null);
		  setToDate(null);
		} else {
		  const today = new Date();
		  setFromDate(today);
		  setToDate(today);
		}
	  
		setTodayActive(!todayActive);
	  };

	  useEffect(() => {
		if (fromDate || toDate) {
		  const today = new Date();
		  const isToday =
			fromDate?.toDateString() === today.toDateString() &&
			toDate?.toDateString() === today.toDateString();
	  
		  setTodayActive(isToday);
		}
	  }, [fromDate, toDate]);
	  
	  


	return (
		<Sidebar
			visible={filterDrawerVisible}
			position="right"
			onHide={() => setFilterDrawerVisible(false)}
			style={{ width: '28rem', maxWidth: '90vw' }}
			header="Filters"
		>
			<div className="d-flex flex-column justify-content-between h-100 gap-1">
				<div>
					<div className="field">
						<label htmlFor="partyType">Party Type</label>
						<Dropdown
							inputId="partyType"
							value={partyType}
							onChange={(e) => setPartyType(e.value)}
							options={partyTypeItems}
							optionLabel="name"
							placeholder="Select Party type"
							className="w-100 md:h-3rem p-inputtext-sm"
						/>
					</div>

					<div className="field">
						<label htmlFor="partyName">Search Party Name</label>
						<span className="p-input-icon-left w-100">
							<i className="pi pi-search" />
							<InputText
								id="partyName"
								type="search"
								value={searchText}
								onInput={(e) => setSearchText(e.target.value)}
								placeholder="Search Party Name"
								className="md:h-3rem w-100 p-inputtext-sm"
								onKeyPress={(e) => {
									if (e.key === 'Enter') handleSearch();
								}}
							/>
						</span>
					</div>

					<div className="field">
						<label htmlFor="partyId">Search by party Id</label>
						<span className="p-input-icon-left w-100">
							<i className="pi pi-search" />
							<InputText
								id="partyId"
								type="search"
								value={searchPartyId}
								onInput={(e) => setSearchPartyId(e.target.value)}
								placeholder="Search by party Id"
								className="md:h-3rem w-100 p-inputtext-sm"
								onKeyPress={(e) => {
									if (e.key === 'Enter') handleSearch();
								}}
							/>
						</span>
					</div>

					<div className="d-flex gap-2">
						<div className="field">
							<label htmlFor="fromDate">From Date</label>
							<Calendar
								id="fromDate"
								value={fromDate}
								onChange={(e) => setFromDate(e.value)}
								dateFormat="yy-mm-dd"
								placeholder="YYYY-MM-DD"
								showIcon
								className="w-100"
								inputClassName="md:h-3rem w-100 p-inputtext-sm"
							/>
						</div>

						<div className="field">
							<label htmlFor="toDate">To Date</label>
							<Calendar
								id="toDate"
								value={toDate}
								onChange={(e) => setToDate(e.value)}
								dateFormat="yy-mm-dd"
								placeholder="YYYY-MM-DD"
								showIcon
								className="w-100"
								inputClassName="md:h-3rem w-100 p-inputtext-sm"
							/>
						</div>
					</div>
					<div className="field">
						<label>Quick Date Filters</label>
						<div className="d-flex gap-2">
						<button
						type="button"
						className={`btn w-100 quick-today-btn ${todayActive ? 'active' : ''}`}
						onClick={handleTodayFilter}
						disabled={loading}
						>
							Today
						</button>
						</div>
					</div>
				</div>

				<div className="d-flex gap-2 justify-content-between mt-2 pt-3 border-top prime-react-btn">
					<Button
						variant="outline-secondary"
						disabled={loading}
						onClick={handleResetFilter}
						className="w-100"
					>
						Reset
					</Button>
					<button
						disabled={loading}
						onClick={handleSearch}
						className="w-100 btn submit-btn text-white"
					>
						Search
					</button>
				</div>
			</div>
		</Sidebar>
	);
};

export default PartyListingFilterDrawer;
